import React, { createContext, useContext, useState, useMemo } from "react";

const ThemeModeContext = createContext();

export const ThemeModeProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(() => /true/i.test(localStorage.getItem("isThemeDark")));

  const toggleTheme = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    localStorage.setItem("isThemeDark", newIsDark);
  };

  const value = useMemo(() => ({ isDark, toggleTheme }), [isDark]);

  return <ThemeModeContext.Provider value={value}>{children}</ThemeModeContext.Provider>;
};

export const useThemeMode = () => useContext(ThemeModeContext);
